(() => {
  const routesNode = document.querySelector('[data-theme-routes]');
  const config = routesNode ? JSON.parse(routesNode.textContent) : {};
  const liveRegion = document.querySelector('[data-live-region]');
  let lastFocused = null;

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
  const formatMoney = (cents) => {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    return (config.moneyFormat || '£{{amount}}')
      .replace('{{amount}}', amount)
      .replace('{{ amount }}', amount)
      .replace('{{amount_no_decimals}}', String(Math.round(Number(cents || 0) / 100)))
      .replace('{{ amount_no_decimals }}', String(Math.round(Number(cents || 0) / 100)));
  };
  const announce = (message) => {
    if (!liveRegion) return;
    liveRegion.textContent = '';
    window.setTimeout(() => { liveRegion.textContent = message; }, 40);
  };

  const announcement = document.querySelector('[data-announcement]');
  const announcementWasDismissed = () => {
    try { return window.sessionStorage.getItem('black-kelp-announcement-dismissed') === 'true'; } catch (error) { return false; }
  };
  const rememberAnnouncementDismissal = () => {
    try { window.sessionStorage.setItem('black-kelp-announcement-dismissed', 'true'); } catch (error) { /* Storage can be unavailable in privacy modes. */ }
  };
  if (announcement && announcementWasDismissed()) {
    announcement.closest('.shopify-section-announcement')?.classList.add('is-dismissed');
  }
  document.querySelector('[data-announcement-close]')?.addEventListener('click', () => {
    announcement.closest('.shopify-section-announcement')?.classList.add('is-dismissed');
    rememberAnnouncementDismissal();
  });

  const closeOverlay = (overlay) => {
    if (!overlay) return;
    overlay.setAttribute('aria-hidden', 'true');
    document.querySelectorAll(`[data-drawer-open="${overlay.id}"]`).forEach((button) => button.setAttribute('aria-expanded', 'false'));
    if (!document.querySelector('[aria-hidden="false"].drawer, [aria-hidden="false"].search-overlay')) document.body.classList.remove('drawer-open');
    if (lastFocused) lastFocused.focus();
  };
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const openOverlay = (overlay) => {
    if (!overlay) return;
    document.querySelectorAll('[aria-hidden="false"].drawer, [aria-hidden="false"].search-overlay').forEach(closeOverlay);
    lastFocused = document.activeElement;
    overlay.setAttribute('aria-hidden', 'false');
    document.querySelectorAll(`[data-drawer-open="${overlay.id}"]`).forEach((button) => button.setAttribute('aria-expanded', 'true'));
    document.body.classList.add('drawer-open');
    window.setTimeout(() => overlay.querySelector('input, button, a, select, textarea')?.focus(), 80);
  };
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openOverlay(document.getElementById(opener.dataset.drawerOpen));
      return;
    }
    const closer = event.target.closest('[data-drawer-close]');
    if (closer) closeOverlay(closer.closest('.drawer, .search-overlay'));
  });
  document.addEventListener('keydown', (event) => {
    const activeOverlay = document.querySelector('[aria-hidden="false"].drawer, [aria-hidden="false"].search-overlay');
    if (event.key === 'Escape') document.querySelectorAll('[aria-hidden="false"].drawer, [aria-hidden="false"].search-overlay').forEach(closeOverlay);
    if (event.key === 'Tab' && activeOverlay) {
      const focusable = [...activeOverlay.querySelectorAll(focusableSelector)].filter((element) => !element.hasAttribute('hidden'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });

  const header = document.querySelector('[data-site-header]');
  if (header) {
    const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 60);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  document.querySelectorAll('[data-mega-menu-item]').forEach((item) => {
    const trigger = item.querySelector('[data-mega-menu-trigger]');
    let closeTimer;
    const open = () => {
      window.clearTimeout(closeTimer);
      document.querySelectorAll('[data-mega-menu-item].is-open').forEach((other) => {
        if (other !== item) { other.classList.remove('is-open'); other.querySelector('[data-mega-menu-trigger]')?.setAttribute('aria-expanded', 'false'); }
      });
      item.classList.add('is-open');
      trigger?.setAttribute('aria-expanded', 'true');
      header?.classList.add('has-open-menu');
    };
    const close = () => {
      closeTimer = window.setTimeout(() => {
        item.classList.remove('is-open');
        trigger?.setAttribute('aria-expanded', 'false');
        if (!document.querySelector('[data-mega-menu-item].is-open')) header?.classList.remove('has-open-menu');
      }, 200);
    };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', (event) => { if (!item.contains(event.relatedTarget)) close(); });
    trigger?.addEventListener('click', (event) => {
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      event.preventDefault();
      item.classList.contains('is-open') ? close() : open();
    });
  });

  document.querySelectorAll('[data-faq-tabs]').forEach((faq) => {
    const tabs = [...faq.querySelectorAll('[role="tab"]')];
    const panels = [...faq.querySelectorAll('[role="tabpanel"]')];
    const activate = (tab) => {
      tabs.forEach((item) => { const selected = item === tab; item.setAttribute('aria-selected', String(selected)); item.tabIndex = selected ? 0 : -1; });
      panels.forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        activate(tabs[nextIndex]); tabs[nextIndex].focus();
      });
    });
  });

  document.addEventListener('click', (event) => {
    const minus = event.target.closest('[data-quantity-minus]');
    const plus = event.target.closest('[data-quantity-plus]');
    if (!minus && !plus) return;
    const input = (minus || plus).parentElement.querySelector('input');
    const next = Math.max(Number(input.min || 1), Number(input.value || 1) + (plus ? 1 : -1));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const media = [...gallery.querySelectorAll('[data-media-id]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    let index = 0;
    const show = (nextIndex) => {
      index = (nextIndex + media.length) % media.length;
      media.forEach((item, itemIndex) => item.classList.toggle('hidden', itemIndex !== index));
      thumbs.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
    };
    thumbs.forEach((thumb, thumbIndex) => thumb.addEventListener('click', () => show(thumbIndex)));
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(index - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(index + 1));
    gallery.showMedia = (mediaId) => {
      const nextIndex = media.findIndex((item) => String(item.dataset.mediaId) === String(mediaId));
      if (nextIndex >= 0) show(nextIndex);
    };
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const variantsNode = section.querySelector('[data-product-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const form = section.querySelector('.product-form');
    if (!form || !variants.length) return;
    const optionGroups = [...form.querySelectorAll('[data-option-position]')];
    const variantInput = form.querySelector('[data-variant-id]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const addText = form.querySelector('[data-add-to-cart-text]');
    const availability = form.querySelector('[data-product-availability]');
    const dynamicCheckout = form.querySelector('[data-dynamic-checkout]');
    const price = section.querySelector('[data-product-price]');
    const compare = section.querySelector('[data-compare-price]');
    const updateVariant = () => {
      const selected = optionGroups.map((group) => group.querySelector('input:checked')?.value);
      optionGroups.forEach((group) => {
        const selectedLabel = group.querySelector('[data-selected-option]');
        if (selectedLabel) selectedLabel.textContent = group.querySelector('input:checked')?.value || '';
      });
      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          const candidate = [...selected];
          candidate[groupIndex] = input.value;
          const compatible = variants.some((item) => item.available && item.options.every((option, index) => !candidate[index] || option === candidate[index]));
          input.disabled = !compatible && !input.checked;
        });
      });
      const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
      if (!variant) {
        variantInput.value = '';
        addButton.disabled = true;
        addText.textContent = 'Unavailable';
        availability.textContent = optionGroups.some((group) => group.hasAttribute('data-required-option') && !group.querySelector('input:checked')) ? 'Select a size to continue' : 'This combination is unavailable';
        availability.classList.add('is-unavailable');
        dynamicCheckout?.classList.add('hidden');
        return;
      }
      variantInput.value = variant.id;
      price.textContent = formatMoney(variant.price);
      if (compare) {
        compare.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
        compare.classList.toggle('hidden', !(variant.compare_at_price > variant.price));
      }
      addButton.disabled = !variant.available;
      addText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      availability.textContent = variant.available ? 'In stock and ready to ship' : 'This option is unavailable';
      availability.classList.toggle('is-unavailable', !variant.available);
      dynamicCheckout?.classList.toggle('hidden', !variant.available);
      if (variant.featured_media?.id) section.querySelector('[data-product-gallery]')?.showMedia?.(variant.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    optionGroups.forEach((group) => group.addEventListener('change', updateVariant));
    updateVariant();
  });

  const fetchCart = () => fetch(`${config.cart}.js`, { headers: { Accept: 'application/json' } }).then((response) => {
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  });
  const renderCart = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = cart.item_count;
      node.classList.toggle('hidden', cart.item_count === 0);
    });
    const container = document.querySelector('[data-cart-drawer-items]');
    const footer = document.querySelector('[data-cart-drawer-footer]');
    if (!container) return;
    if (!cart.items.length) {
      container.innerHTML = '<div class="empty-state"><p class="display-text">Nothing but sea air.</p><p>Your cart is empty.</p><a class="text-link" href="' + escapeHtml(config.root || '/') + 'collections/all">Continue shopping</a></div>';
      footer?.classList.add('hidden');
    } else {
      container.innerHTML = '<ul class="cart-lines" role="list">' + cart.items.map((item) => {
        const variant = item.product_has_only_default_variant ? '' : `<p>${escapeHtml(item.variant_title || '')}</p>`;
        return `<li class="cart-line" data-line-key="${escapeHtml(item.key)}"><a class="cart-line__image" href="${escapeHtml(item.url)}"><img src="${escapeHtml(item.image || '')}" width="180" height="240" loading="lazy" alt="${escapeHtml(item.product_title)}"></a><div class="cart-line__content"><div class="cart-line__top"><div><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>${variant}</div><strong>${formatMoney(item.final_line_price)}</strong></div><div class="cart-line__actions"><div class="quantity"><button type="button" data-cart-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button></div><button class="text-button" type="button" data-cart-remove>Remove</button></div></div></li>`;
      }).join('') + '</ul>';
      footer?.classList.remove('hidden');
    }
    document.querySelector('[data-cart-total]')?.replaceChildren(document.createTextNode(formatMoney(cart.total_price)));
    const progress = document.querySelector('[data-cart-progress]');
    if (progress) {
      const threshold = Number(progress.dataset.threshold || 0);
      const remaining = Math.max(0, threshold - cart.total_price);
      const message = threshold === 0 || remaining === 0 ? 'Free UK delivery unlocked.' : `Add ${formatMoney(remaining)} for free UK delivery.`;
      progress.querySelector('[data-cart-progress-text]').textContent = message;
      progress.querySelector('[data-cart-progress-bar]').style.width = `${threshold ? Math.min(100, (cart.total_price / threshold) * 100) : 100}%`;
    }
  };
  const refreshCart = () => fetchCart().then((cart) => { renderCart(cart); return cart; });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-ajax-product-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const original = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const response = await fetch(`${config.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this item');
      await refreshCart();
      if (button) button.textContent = 'Added ✓';
      announce(`${result.product_title || 'Item'} added to cart`);
      if (config.cartDrawerEnabled !== false) openOverlay(document.getElementById('CartDrawer'));
      window.setTimeout(() => { if (button) { button.disabled = false; button.textContent = original; } }, 1600);
    } catch (error) {
      if (button) { button.disabled = false; button.textContent = original; }
      announce(error.message);
      window.alert(error.message);
    }
  });
  document.addEventListener('click', async (event) => {
    const quantityButton = event.target.closest('[data-cart-quantity], [data-cart-remove]');
    if (!quantityButton) return;
    const line = quantityButton.closest('[data-line-key]');
    if (!line) return;
    quantityButton.disabled = true;
    try {
      const response = await fetch(`${config.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.dataset.lineKey, quantity: quantityButton.hasAttribute('data-cart-remove') ? 0 : Number(quantityButton.dataset.cartQuantity) }) });
      if (!response.ok) throw new Error('Unable to update cart');
      renderCart(await response.json());
      announce('Cart updated');
    } catch (error) { announce(error.message); }
  });
  if (document.querySelector('[data-cart-progress]')) refreshCart().catch(() => {});

  const predictiveInput = document.querySelector('[data-predictive-search-input]');
  const predictiveResults = document.querySelector('[data-predictive-search-results]');
  let searchTimer;
  const runPredictiveSearch = (query) => {
    if (!predictiveResults || query.trim().length < 2) return;
    predictiveResults.innerHTML = '<p class="caption">Searching the deep…</p>';
    const endpoint = `${config.predictiveSearch}.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page,article&resources[limit]=6`;
    fetch(endpoint).then((response) => response.json()).then((payload) => {
      const resources = payload.resources?.results || {};
      const items = [...(resources.products || []), ...(resources.collections || []), ...(resources.pages || []), ...(resources.articles || [])];
      if (!items.length) { predictiveResults.innerHTML = '<p class="caption">Nothing surfaced. Press Enter to see all search results.</p>'; return; }
      predictiveResults.innerHTML = '<p class="eyebrow">Results</p><div class="predictive-grid">' + items.map((item) => {
        const image = item.featured_image?.url || item.image || '';
        const imageUrl = image ? `${image}${image.includes('?') ? '&' : '?'}width=120` : '';
        const imageTag = imageUrl ? `<img src="${escapeHtml(imageUrl)}" width="60" height="76" loading="lazy" alt="">` : '';
        const meta = item.price ? formatMoney(item.price) : (item.type || 'Story');
        return `<a class="predictive-item" href="${escapeHtml(item.url)}">${imageTag}<span><strong>${escapeHtml(item.title)}</strong><small>${escapeHtml(meta)}</small></span></a>`;
      }).join('') + '</div>';
    }).catch(() => { predictiveResults.innerHTML = '<p class="caption">Search is temporarily unavailable.</p>'; });
  };
  predictiveInput?.addEventListener('input', () => { window.clearTimeout(searchTimer); searchTimer = window.setTimeout(() => runPredictiveSearch(predictiveInput.value), 180); });
  document.querySelectorAll('[data-search-suggestion]').forEach((button) => button.addEventListener('click', () => { predictiveInput.value = button.dataset.searchSuggestion; predictiveInput.focus(); runPredictiveSearch(predictiveInput.value); }));

  const filterPanel = document.querySelector('[data-filter-panel]');
  document.querySelector('[data-filter-toggle]')?.addEventListener('click', (event) => { filterPanel?.classList.add('is-open'); event.currentTarget.setAttribute('aria-expanded', 'true'); document.body.classList.add('drawer-open'); });
  document.querySelector('[data-filter-close]')?.addEventListener('click', () => { filterPanel?.classList.remove('is-open'); document.querySelector('[data-filter-toggle]')?.setAttribute('aria-expanded', 'false'); document.body.classList.remove('drawer-open'); });
  document.querySelectorAll('[data-auto-submit]').forEach((control) => control.addEventListener('change', () => control.form.submit()));

  document.querySelectorAll('[data-product-recommendations]').forEach((section) => {
    if (section.innerHTML.trim().length > 100) return;
    fetch(section.dataset.url).then((response) => response.text()).then((text) => {
      const html = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-product-recommendations]');
      if (html?.innerHTML.trim()) section.innerHTML = html.innerHTML;
    }).catch(() => {});
  });
  document.querySelectorAll('[data-confirm-message]').forEach((button) => button.addEventListener('click', (event) => { if (!window.confirm(button.dataset.confirmMessage)) event.preventDefault(); }));
})();
